module.exports = __webpack_public_path__ + "static/img/04996740.eeaff09e.png";